import React, { useCallback } from 'react'
import { TransformData } from 'react-admin'
import { SaveWithConfirmButton } from './index'
import { SaveWithConfirmButtonProps } from './type'

const UnpublishButton: React.FC<SaveWithConfirmButtonProps> = ({
  encType = 'application/json',
  ...props
}) => {
  const transformUnpublish: TransformData = useCallback(
    (data) => ({ ...data, is_published: false }),
    [],
  )
  return (
    <SaveWithConfirmButton
      label='ra.action.unpublish'
      confirmTitle='ra.message.confirmation.unpublish.title'
      confirmContent='ra.message.confirmation.unpublish.content'
      alwaysEnable
      transform={transformUnpublish}
      color='error'
      encType={encType}
      type='button'
      icon={<></>}
      {...props}
    />
  )
}

export default UnpublishButton
